import { render, staticRenderFns } from "./ok.vue?vue&type=template&id=234ee9a3&scoped=true&lang=pug&"
import script from "./ok.vue?vue&type=script&lang=ts&"
export * from "./ok.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ee9a3",
  null
  
)

export default component.exports